var chunkToChildrenMap = {
	"1026": [
		3493,
		5189,
		9896,
		1554,
		6774,
		1613
	],
	"2435": [
		5435,
		8725,
		1027
	],
	"3065": [
		5824,
		8304,
		4199,
		9510,
		4043,
		585,
		7089,
		6012,
		8757,
		960,
		599,
		4079
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));